import React from "react";
import { BrowserRouter, Switch, Route, HashRouter } from "react-router-dom";
import Landing from "./components/landing/landing";
import Notes from "../src/components/notes/Notes";
import QB from "./components/questionBank/QuestionBank";
import ThirdSemesterNotes from "./components/notes/Third";
import FourthSemesterNotes from "./components/notes/Fourth";
import FifthSemesterNotes from "./components/notes/Fifth";
import SixthSemesterNotes from "./components/notes/Sixth";
import SeventhSemesterNotes from "./components/notes/seventh";
import EighthSemesterNotes from "./components/notes/Eight";
import ThirdSemesterQuestionBank from "./components/questionBank/QThird";
import FourthSemesterQuestionBank from "./components/questionBank/QFourth";
import FifthSemesterQuestionBank from "./components/questionBank/QFifth";
import SixthSemesterQuestionBank from "./components/questionBank/QSixth";
import SeventhSemesterQuestionBank from "./components/questionBank/Qseventh";
import EighthSemesterQuestionBank from "./components/questionBank/QEight";
import Community from "./components/community/Community";
import Projects from "./components/projects/Project";
import FifthSemProject from "./components/projects/PFifth";
import SixthSemProject from "./components/projects/PSixth";
import SeventhSemProject from "./components/projects/Pseventh";
import EightSemProject from "./components/projects/PEight";
import About from "./components/contact/Aboutus";
import Calc from "./components/Calculator/Calc";
import DownloadApp from "./components/downloadapp/DownloadApp";
import VideoClass from "./components/videoClass/VideoClass";
import ThirdSemVideoClass from "./components/videoClass/ThirdSemVideo";
import SixthSemVideoClass from "./components/videoClass/SixthSemVideo";
import BuyProjectLanding from "./components/projects/BuyProjectLanding";
import PageNotFound from "./components/fileNotFoundPage/Notfound"
import CoronaReport from './components/coronaTracker/CoronaReport'



import ScrollToTop from "react-router-scroll-top";

function App() {
  return (
    <div>


      <BrowserRouter>
        <HashRouter>
          <Switch>
            <Route exact path="/">
              <ScrollToTop>
                <Landing />
              </ScrollToTop>
            </Route>
            <Route exact path="/Notes">
              <ScrollToTop>
                <Notes />
              </ScrollToTop>
            </Route>
            <Route exact path="/3rdSemNotes">
              <ScrollToTop>
                <ThirdSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/4thSemNotes">
              <ScrollToTop>
                <FourthSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/5thSemNotes">
              <ScrollToTop>
                <FifthSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/6thSemNotes">
              <ScrollToTop>
                <SixthSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/7thSemNotes">
              <ScrollToTop>
                <SeventhSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/8thSemNotes">
              <ScrollToTop>
                <EighthSemesterNotes />
              </ScrollToTop>
            </Route>
            <Route exact path="/community">
              <ScrollToTop>
                <Community />
              </ScrollToTop>
            </Route>
            <Route exact path="/QuestionBank">
              <ScrollToTop>
                <QB />
              </ScrollToTop>
            </Route>
            <Route exact path="/3rdSemQuestionBank">
              <ScrollToTop>
                <ThirdSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/4thSemQuestionBank">
              <ScrollToTop>
                <FourthSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/5thSemQuestionBank">
              <ScrollToTop>
                <FifthSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/6thSemQuestionBank">
              <ScrollToTop>
                <SixthSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/7thSemQuestionBank">
              <ScrollToTop>
                <SeventhSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/8thSemQuestionBank">
              <ScrollToTop>
                <EighthSemesterQuestionBank />
              </ScrollToTop>
            </Route>
            <Route exact path="/Projects">
              <ScrollToTop>
                <Projects />
              </ScrollToTop>
            </Route>
            <Route exact path="/5thSemProject">
              <ScrollToTop>
                <FifthSemProject />
              </ScrollToTop>
            </Route>
            <Route exact path="/6thSemProject">
              <ScrollToTop>
                <SixthSemProject />
              </ScrollToTop>
            </Route>
            <Route exact path="/7thSemProject">
              <ScrollToTop>
                <SeventhSemProject />
              </ScrollToTop>
            </Route>
            <Route exact path="/8thSemProject">
              <ScrollToTop>
                <EightSemProject />
              </ScrollToTop>
            </Route>
            <Route exact path="/BuyProjects">
              <ScrollToTop>
                <BuyProjectLanding />
              </ScrollToTop>
            </Route>
            <Route exact path="/about">
              <ScrollToTop>
                <About />
              </ScrollToTop>
            </Route>
            <Route exact path="/Calculator">
              <ScrollToTop>
                <Calc />
              </ScrollToTop>
            </Route>
            <Route exact path="/download">
              <ScrollToTop>
                <DownloadApp />
              </ScrollToTop>
            </Route>
            <Route exact path="/VideoClass">
              <ScrollToTop>
                <VideoClass />
              </ScrollToTop>
            </Route>
            <Route exact path="/ThirdSemVideoClass">
              <ScrollToTop>
                <ThirdSemVideoClass />
              </ScrollToTop>
            </Route>
            <Route exact path="/SixthSemVideo">
              <ScrollToTop>
                <SixthSemVideoClass />
              </ScrollToTop>
            </Route>
            <Route exact path="/Notfound">
              <ScrollToTop>
                <PageNotFound />
              </ScrollToTop>
            </Route>
            <Route exact path="/CoronaReport">
              <ScrollToTop>
                <CoronaReport />
              </ScrollToTop>
            </Route>
          
          </Switch>
        </HashRouter>
      </BrowserRouter>
    </div>
  );
}

export default App;
